import { IconContent } from '@icons';

export const chevronLeft: IconContent = {
    sm: '<path d="m5.22 7.823 4.853 4.854.707-.707-4.146-4.147 4.146-4.146-.707-.707L5.22 7.823Z" />',
};
